import React from "react";
import {
    Box,
    Container,
    Typography,
    Grid,
    Link,
    List,
    ListItem,
    Divider,
    IconButton,
} from "@mui/material";
import {
    LinkedIn,
    Twitter,
    WhatsApp,
    Phone,
    Email,
} from "@mui/icons-material";

function PrivacyPolicy() {
    return (
        <>
            <Container maxWidth="lg" sx={{ py: 2 }}>
                <Typography
                    variant="h3"
                    align="center"
                    gutterBottom
                    sx={{
                        fontWeight: "bold",
                        color: "#030366",
                        mt: 7,
                        fontSize: {
                            xs: "1.8rem",  // mobile (~h4)
                            sm: "2.2rem",  // tablet (~h3)
                            md: "2.8rem",  // laptop (~h3+)
                            lg: "3rem",    // desktop (~h2)
                        },
                    }}
                >
                    Privacy Policy
                </Typography>

                <Box sx={{ typography: "body1" }}>
                    <Typography paragraph>
                        VENSYX DATA SOLUTIONS ("us", "we", or "our") operates the http://www.vensyx.com website (the "Service"). “You” , “Your” refers to the customers / Clients
                        This page informs you of our policies regarding the collection, use, and disclosure of personal data when you use our Service and the choices you have associated with that data.
                    </Typography>

                    <Typography>
                        We use your data to provide and improve the Service. By using the Service, you agree to the collection and use of information in accordance with this policy. Unless otherwise defined in this Privacy Policy, terms used in this Privacy Policy have the same meanings as in our Terms and Conditions, accessible from http://www.vensyx.com
                    </Typography>

                    <Typography variant="h5" sx={{ mt: 3, fontWeight: 600 }}>
                        1. Information Collection And Use
                    </Typography>
                    <Typography paragraph>
                        We collect several different types of information for various purposes to provide and improve our Service to you.
                    </Typography>

                    <Typography variant="h6" sx={{ mt: 2 }}>
                        1.1 Personal Data
                    </Typography>

                    <Typography>
                        While using our Service, we may ask you to provide us with certain personally identifiable information that can be used to contact or identify you ("Personal Data").
                    </Typography>
                    <Typography>
                        Personally, identifiable information may include, but is not limited to:
                    </Typography>
                    <List>
                        {[
                            "Email address",
                            "First name and last name",
                            "Phone number",
                            "Address, State, Province, ZIP/Postal code, City",
                            "Cookies and Usage Data",
                        ].map((item, i) => (
                            <ListItem key={i} sx={{ display: "list-item", ml: 3 }}>
                                {item}
                            </ListItem>
                        ))}
                    </List>
                    <Typography variant="h6" sx={{ mt: 2 }}>
                        1.2 Usage Data
                    </Typography>
                    <Typography>
                        We may also collect information how the Service is accessed and used ("Usage Data"). This Usage Data may include information such as your computer's Internet Protocol address (e.g. IP address), browser type, browser version, the pages of our Service that you visit, the time and date of your visit, the time spent on those pages, unique device identifiers and other diagnostic data.
                    </Typography>
                    <Typography variant="h6" sx={{ mt: 2 }}>
                        1.3 Tracking & Cookies Data
                    </Typography>
                    <Typography>
                        We use cookies and similar tracking technologies to track the activity on our Service and hold certain information.
                    </Typography>
                    <Typography>
                        Cookies are files with small amount of data which may include an anonymous unique identifier. Cookies are sent to your browser from a website and stored on your device. Tracking technologies used are beacons, tags, and scripts to collect and track information and to improve and analyze our Service.
                    </Typography>
                    <Typography>
                        You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. However, if you do not accept cookies, you may not be able to use some portions of our Service.
                    </Typography>
                    <Typography variant="h5" sx={{ mt: 3, fontWeight: 600 }}>
                        2. Use of Data
                    </Typography>
                    <Typography>
                        VENSYX DATA SOLUTIONS uses the collected data for various purposes:
                    </Typography>
                    <List>
                        {[
                            "To provide and maintain the Service",
                            "To notify you about changes to our Service",
                            "To allow you to participate in interactive features of our Service when you choose to do so",
                            "To provide customer care and support",
                            "To provide analysis or valuable information so that we can improve the Service",
                            "To monitor the usage of the Service",
                            "To detect, prevent and address technical issues"
                        ].map((item, i) => (
                            <ListItem key={i} sx={{ display: "list-item", ml: 3 }}>
                                {item}
                            </ListItem>
                        ))}
                    </List>
                    <Typography variant="h5" sx={{ mt: 3, fontWeight: 600 }}>
                        3. Data Privacy
                    </Typography>
                    <Typography>
                        VENSYX DATA SOLUTIONS will take all steps reasonably necessary to ensure that your data is treated securely and in accordance with this Privacy Policy and no transfer of your Personal Data will take place to an organization or a country unless there are adequate controls in place including the security of your data and other personal information.
                    </Typography>
                    <Typography variant="h5" sx={{ mt: 3, fontWeight: 600 }}>
                        4. Disclosure Of Data
                    </Typography>
                    <Typography>
                        VENSYX DATA SOLUTIONS may disclose your Personal Data in the good faith belief that such action is necessary to:
                    </Typography>
                    <List>
                        {[
                            "To comply with a legal obligation",
                            "To protect and defend the rights or property of VENSYX DATA SOLUTIONS",
                            "To prevent or investigate possible wrongdoing in connection with the Service",
                            "To protect the personal safety of users of the Service or the public",
                            "To protect against legal liability",
                        ].map((item, i) => (
                            <ListItem key={i} sx={{ display: "list-item", ml: 3 }}>
                                {item}
                            </ListItem>
                        ))}
                    </List>
                    <Typography variant="h5" sx={{ mt: 3, fontWeight: 600 }}>
                        5. Security Of Data
                    </Typography>
                    <Typography>
                        The security of your data is important to us, but remember that no method of transmission over the Internet, or method of electronic storage is 100% secure. While we strive to use commercially acceptable means to protect your Personal Data, we cannot guarantee its absolute security.
                    </Typography>
                    <Typography variant="h5" sx={{ mt: 3, fontWeight: 600 }}>
                        6. Service Providers
                    </Typography>
                    <Typography>
                        We may employ third party companies and individuals to facilitate our Service ("Service Providers"), to provide the Service on our behalf, to perform Service-related services or to assist us in analyzing how our Service is used.
                    </Typography>
                    <Typography>
                        These third parties have access to your Personal Data only to perform these tasks on our behalf and are obligated not to disclose or use it for any other purpose.
                    </Typography>
                    <Typography variant="h5" sx={{ mt: 3, fontWeight: 600 }}>
                        7. Links To Other Sites
                    </Typography>
                    <Typography>
                        Our Service may contain links to other sites that are not operated by us. If you click on a third party link, you will be directed to that third party's site. We strongly advise you to review the Privacy Policy of every site you visit.
                    </Typography>
                    <Typography>
                        We have no control over and assume no responsibility for the content, privacy policies or practices of any third party sites or services.
                    </Typography>
                    <Typography variant="h5" sx={{ mt: 3, fontWeight: 600 }}>
                        8. Children's Privacy
                    </Typography>
                    <Typography>
                        We do not knowingly collect personally identifiable information from anyone under the age of 18. If you are a parent or guardian and you are aware that your Children has provided us with Personal Data, please contact us. If we become aware that we have collected Personal Data from children without verification of parental consent, we take steps to remove that information from our servers.
                    </Typography>
                    <Typography variant="h5" sx={{ mt: 3, fontWeight: 600 }}>
                        9. Changes To This Privacy Policy
                    </Typography>
                    <Typography>
                        We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page.
                    </Typography>
                    <Typography>
                        We will let you know via email and/or a prominent notice on our Service, prior to the change becoming effective and update the "effective date" at the top of this Privacy Policy.
                    </Typography>
                    <Typography>
                        You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page.
                    </Typography>
                    <Typography variant="h5" sx={{ mt: 3, fontWeight: 600 }}>
                        10. Contact Us
                    </Typography>
                    <Typography>
                        If you have any questions about this Privacy Policy, please contact us:
                    </Typography>
                    <List>
                        {[
                            "By email: info@vensyx.com",
                            "By phone number: +91-9000316721"
                        ].map((item, i) => (
                            <ListItem key={i} sx={{ display: "list-item", ml: 3 }}>
                                {item}
                            </ListItem>
                        ))}
                    </List>
                </Box>
            </Container>
        </>
    );
}

export default PrivacyPolicy;
